import Routes from "./routes";
import { default as UpgradeModal } from "views/containers/UpgradeModalContainer";
import { default as ConfirmationModal } from "views/containers/ConfirmationModalContainer";
import { default as CollectionPreviewModal } from "views/containers/CollectionPreviewModalContainer";
import { default as RequestApprovalModal } from "views/containers/RequestApprovalModalContainer";
import { default as ApprovalModal } from "views/components/ApprovalModal/ApprovalModalContainer";
import { default as PurchaseCollectionModal } from "views/components/PurchaseCollection/PurchaseCollectionModalContainerGlobal.js";
import { default as DndUploadProgressToast } from "views/components/DndUploadProgressToast";
import { ToastContainer, Slide } from "react-toastify";

const Modals = () => (
  <>
    <UpgradeModal />
    <ConfirmationModal />
    <CollectionPreviewModal />
    <RequestApprovalModal />
    <ApprovalModal />
    <PurchaseCollectionModal />
  </>
);

const RootRoute = () => (
  <>
    <Routes />
    <Modals />
    <DndUploadProgressToast />
    <ToastContainer
      autoClose={8000}
      draggable={false}
      closeOnClick={false}
      position="bottom-right"
      hideProgressBar
      style={{
        width: "450px",
        bottom: "0.25em",
        right: "2em"
      }}
      closeButton={false}
      transition={Slide}
    />
  </>
);

export default RootRoute;
